export default {
	weldMode: {
		selectFacesPrompt: "Selezionate le superfici da saldare.",
		weldlineLabel: "Cordone di saldatura",
		selectFacePrompt: "Selezionare una superficie...",
		selectMoreFacesPrompt: "Selezionare altre superfici o applicare...",
		helpLink: "Aiuto",
		applyButtonTitle: "Crea i cordoni di saldatura selezionati.",
		applyButton: "Applica",
		maxDistanceFallback: "la distanza massima consentita tra i materiali",
		someWeldsFailedMessage:
			"L'algoritmo non trova un modo per creare un cordone di saldatura tra alcune superfici. " +
			"Assicuratevi che la distanza tra le superfici non superi {distance} e che i bordi siano paralleli.",
		errorListIntro: "Di seguito sono elencati i singoli messaggi di errore:",
		someWeldsFailedTitle: "Non è stato possibile definire alcuni cordoni di saldatura.",
		weldDefinitionFailedTitle: "Non è possibile definire il cordone di saldatura.",
	},
	weldlines: {
		existingWeldlinesTitle: "Cordoni di saldatura esistenti",
		cleanAllCheckboxLabel: "Molare tutti i cordoni di saldatura",
		weldlineLabel: "Cordone di saldatura",
		fillerLabel: "da riempire",
		pluggedLabel: "a tappo",
		withCornersLabel: "con",
		cornerLabel: "Angolo",
		cornerTooltipChoose: "Selezionate se questo angolo deve essere saldato oppure no.",
		cornerTooltipTooLarge: "Questo angolo è troppo grande per essere saldato. Consultate la nostra",
		cornerTooltipConstructionLink: "indicazione costruttiva.",
		defineSegmentsTitle: "Definisci pattern",
		deleteWeldlineTitle: "Elimina cordone di saldatura",
		segmentDialogTitle: "Suddividi il cordone di saldatura in segmenti.",
		segmentDialogInfo1:
			"Il cordone di saldatura può essere saldato per l'intera lunghezza. Questo garantisce un'elevata " +
			"resistenza, ma comporta anche un elevato apporto di calore e quindi una possibile deformazione del pezzo.",
		segmentDialogInfo2:
			"Suddividendo il cordone di saldatura in segmenti brevi è possibile contrastare questo effetto.",
		numberOfSegmentsLabel: "Numero di segmenti:",
		segmentLengthLabel: "Lunghezza di un segmento [mm]:",
		singleSegmentInfo:
			"Se viene definito un solo segmento, la sua lunghezza viene impostata automaticamente uguale alla lunghezza del cordone di saldatura.",
		applyButton: "Applica",
		cancelButton: "Annulla",
		errorSegmentsMustBeInteger: "Il numero di segmenti deve essere un numero intero.",
		errorSegmentsMinOne: "Il numero di segmenti deve essere almeno 1.",
		errorSegmentMinLength: "Un segmento deve essere lungo almeno 5 mm.",
		errorSegmentsTotalTooLong:
			"La lunghezza totale dei segmenti supera quella del cordone di saldatura. " +
			"Tenete inoltre presente che tra i segmenti deve rimanere una distanza di almeno 5 mm.",
	},
	rollDirectionMode: {
		noDirectionDefined:
			"Non è ancora stata definita alcuna direzione di laminazione. Selezionate un bordo esterno per la direzione di laminazione.",
		adjustHint:
			"Potete definire l'andamento della direzione di laminazione modificando l'angolo oppure facendo clic su un altro bordo esterno.",
		angleRangeLabel: "(da 0° a 180°)",
	},
	measuringMode: {
		selectPrompt: "Selezionate superfici o bordi da misurare.",
	},
};
